define(['jquery', 'backbone'], function ($, Backbone) {
    'use strict';

    var $el = $('.generated-schema-form[data-schema="BrochureRequest"]');
    if ($el.length === 0) {
        return;
    }

    new (Backbone.View.extend({

        'events': {

            'change input[name="root[type]"]': 'toggleAvailableChannels',

            'submit': function (event) {
                var $form = $(event.currentTarget);

                $form.find('button[type="submit"]').prev().css('opacity', 0.6).next().replaceWith(
                    '<div class="submit-loader"><img src="/img/loading.gif"/>Even geduld a.u.b.</div>');
            }

        },

        toggleAvailableChannels: function (event) {
            this.$el.find('#channel-post')
            .parents('.schema-property-channel').toggle($(event.currentTarget).val() === '2');
        }

    }))({el: $el}).render();
});
